import { BaseEnum } from '@/lib/base-enum';
import { CompanySimpleInfoDto, UserDto } from '@wanjia/panama-sdk';

export class UserStatus extends BaseEnum {
  static readonly GUEST = new UserStatus('GUEST', '游客');
  static readonly ACTIVE = new UserStatus('ACTIVE', '活跃用户');
  static readonly DISABLED = new UserStatus('DISABLED', '禁止登录');
  static readonly ALL = new UserStatus('ALL', '全部');
}

export class User implements UserDto {
  id!: string;
  powerGroup?: string;
  status!: string;
  salt?: string;
  pwd?: string;
  name?: string;
  enName?: string;
  username?: string;
  code?: string;
  nickname?: string;
  mobile?: string;
  telephone?: string;
  qq?: string;
  wechat?: string;
  email?: string;
  gender?: number;
  avatar?: string;
  province?: string;
  city?: string;
  birthday?: number;
  address?: string;
  jobTitle?: string;
  realName?: string;
  idCard?: string;
  realStatus?: number;
  referrer?: string;
  channelCode?: string;
  requestId?: string;
  inviteCode?: string;
  subscribe?: number;
  description?: string;
  note?: string;
  lastLoginTime?: number;
  lastCreateOrderTime?: number;
  lastLoginLanguage?: string;
  tags?: string[];
  createTime?: number;
  updateTime?: number;
  companies?: CompanySimpleInfoDto[];
}
